import DbService from 'resources/db.service';
import schema from './advanced-fields-to-company.schema';

const service = new DbService('advanced_fields_to_company', { schema });

const toggleFieldStatus = async (fieldId, companyId, deactivate) => {
  const response = await service.updateOne(
    { field_id: fieldId, company_id: companyId },
    { is_active: !deactivate }
  );
  return response;
}

const batchToggleFieldStatus = async (fieldIds, companyId, deactivate) => {
  // const selectResponse = await service
  //   .select('field_id')
  //   .eq('company_id', companyId)
  //   .in('field_id', fieldIds);

  const selectResponse = await service.selectByKey({
    selectKey: 'batchToggleFieldStatus',
    params: { fieldIds },
  });

  const { data: fieldsToUpdate } = service.processResponse(selectResponse);

  // Update each field
  const updatePromises = fieldsToUpdate.map(field => {
    return toggleFieldStatus(field.field_id, companyId, deactivate);
  });

  // Wait for all updates to complete
  const response = await Promise.all(updatePromises);
  return service.processResponse(response);
}

export default Object.assign(service, {
  batchToggleFieldStatus,
});
